import ApiClient from '../apiClient';

export type ChatProcessingValue = 'all time' | 'custom work time' | 'AI' | 'not specified';

export interface ModelOfferPayload {
  commission: number;
  prohibited_sources: string[];
  show_service_info_for_partner?: boolean;
  custom_media_for_partner?: boolean;
  exist_chatters?: boolean;
  chat_processing?: ChatProcessingValue;
  free_trial_access?: boolean;
  description?: string;
  contact_for_content?: string | null;
  status?: 'moderation' | 'refusal' | 'hidden' | 'active';
}

const clientOfferService = {
  createOffer: (ofModelId: number | string, payload: ModelOfferPayload) => {
    return ApiClient.post(`/models/${ofModelId}/offer`, payload);
  },
  updateOffer: (ofModelId: number | string, payload: ModelOfferPayload) => {
    return ApiClient.put(`/models/${ofModelId}/offer`, payload);
  },
};

export default clientOfferService;
